$('.anchor-btn').on('click', (e) => {
	let $this = $(e.currentTarget);

	let destination = $this.attr('href');

	let headerHeight = $('.header').outerHeight();

	$('html, body').animate({
		scrollTop: $(`${destination}`).offset().top - headerHeight,
	}, 750);

	return false;
});

$('.mobile-menu__link').on('click', (e) => {
	let $this = $(e.currentTarget);

	let destination = $this.attr('href');

	let headerHeight = $('.header').outerHeight();

	$('html, body').animate({
		scrollTop: $(`${destination}`).offset().top - headerHeight,
	}, 750);

	$('.header').removeClass('is-active');
	$('.mobile-panel').hide();
	$('body').removeClass('is-menu-open');

	return false;
});

$(window).on('load', () => {
	if (window.location.hash) {
		setTimeout(() => {
			let hash = window.location.hash.substring(1);

			let headerHeight = $('.header').outerHeight();

			$('html, body').animate({
				scrollTop: $(`#${hash}`).offset().top - headerHeight,
			}, 750);
		}, 2000);
	}
});
